export const useImageSize = (url) => {
    try {
        const http = new XMLHttpRequest();
        http.open('HEAD', url, false);
        http.send(null);
        if (http.status === 200) {
            let contentLength = http.getResponseHeader('content-length');
            if (!contentLength)
                contentLength = '20240';
            return {
                size: parseInt(contentLength),
                mimeType: http.getResponseHeader('Content-Type'),
            };
        }
        return {
            size: 0,
            mimeType: '',
        };
    }
    catch (error) {
        console.error(error);
        return {
            size: 0,
            mimeType: '',
        };
    }
};
